import React from "react";
import { Download, Github, Linkedin, MessageCircleMore } from "lucide-react";
import profileImage from "../assets/profile.jpeg";

const Hero = ({ scrollToSection }) => {
  return (
    <section id="home" className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              Hi, I'm <span className="highlight">Muhammad Anas</span>
            </h1>
            <h2 className="hero-subtitle">Software Engineer</h2>
            <p className="hero-description">
              Software Engineering student at COMSATS who builds practical,
              user-focused applications with Java, React, and TypeScript. I
              enjoy turning complex requirements into clean interfaces, reliable
              APIs, and maintainable software.
            </p>
            <div className="hero-buttons">
              <button
                className="btn btn-primary"
                onClick={() => scrollToSection("projects")}
              >
                View My Work
              </button>
              <a
                href="/Muhammad_Anas_Resume.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-outline"
                style={{
                  textDecoration: "none",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  justifyContent: "center",
                }}
              >
                <Download size={20} />
                View Resume
              </a>
            </div>
            <div className="social-links">
              <a
                href="https://github.com/MuhammadAnas126"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Github size={24} />
              </a>
              <a
                href="https://www.linkedin.com/in/muhammad-anas0/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Linkedin size={24} />
              </a>
              <a
                href="https://wa.me/923084260003?text=Hi%2C%20I%20visited%20your%20portfolio%20and%20wanted%20to%20connect!"
                target="_blank"
                rel="noopener noreferrer"
              >
                <MessageCircleMore size={24} />
              </a>
            </div>
          </div>
          <div className="hero-image">
            <div className="image-container">
              <img src={profileImage} alt="Muhammad Anas" />
              <div className="image-glow"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
